'use client';

import { useParams } from 'next/navigation';
import { useQuery } from '@tanstack/react-query';
import { PublicBrandingNav } from '../../../components/layout/PublicBrandingNav';
import { fetchPublicShelterLookup } from '../api/publicSheltersApi';
import { adoptQuizKeys } from '../queryKeys';

export type AdoptQuizBrandingNavProps = {
  sticky?: boolean;
  className?: string;
};

/** Loads shelter logo for `/adopt/[shelterKey]` and renders {@link PublicBrandingNav}. */
export function AdoptQuizBrandingNav({
  sticky = false,
  className,
}: AdoptQuizBrandingNavProps) {
  const params = useParams();
  const rawKey = params?.shelterKey;
  const segment =
    typeof rawKey === 'string' ? rawKey : Array.isArray(rawKey) ? rawKey[0] : '';

  const lookupQuery = useQuery({
    queryKey: adoptQuizKeys.publicShelterLookup(segment),
    queryFn: () => fetchPublicShelterLookup(segment),
    enabled: Boolean(segment),
    staleTime: 60_000,
  });

  return (
    <PublicBrandingNav
      sticky={sticky}
      className={className}
      shelterLogoUrl={lookupQuery.data?.logoSignedUrl ?? null}
      shelterUrl={lookupQuery.data?.shelterUrl ?? null}
      shelterName={lookupQuery.data?.name}
      shelterLogoLoading={lookupQuery.isLoading && Boolean(segment)}
    />
  );
}
